import { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import { TooltipQuestionMarkSVG } from '../../../svgComponents/tooltipQuestionMarkSVG';
import { Tooltip } from '../tooltip';
import styles from './DecisionValidationTooltip.module.css';
import messages from './decisionValidityTooltip.messages';

export class DecisionValidationTooltip extends Component {
    renderMessage() {
        const values = this.getValues();
        return (
            <FormattedMessage
                {...messages.creditUtilisationLimitTooltip}
                values={values}
            />
        );
    }

    getValues() {
        const validForNumberOfDays = this.props.validForNumberOfDays;
        return {
            validForNumberOfDays
        };
    }

    renderTooltip() {
        const message = this.renderMessage();
        const { className } = this.props;

        return (
            <Tooltip message={message} className={className}>
                <TooltipQuestionMarkSVG
                    className={classnames(styles.icon, styles.questionIcon)}
                />
            </Tooltip>
        );
    }

    render() {
        const tooltip = this.renderTooltip();

        return <>{tooltip}</>;
    }
}
